module.exports = __webpack_public_path__ + "img/expenses_datail_bg.ebfbff34.png";